import MasterCrudPage from '../../components/MasterCrudPage';

export default function MedicalClaimSettings() {
  return (
    <MasterCrudPage
      config={{
        title: 'Medical Claim Settings',
        apiBase: '/lms/masters/medical-claim-settings',
        listKey: 'medicalClaimSettings',
        entityKey: 'medicalClaimSetting',
        fields: [
          {
            key: 'cutoffMode',
            label: 'Cut-off Mode',
            type: 'select',
            options: [
              { value: 'END_MONTH', label: 'End of Month' },
              { value: 'MID_END', label: 'Mid + End of Month' },
            ],
          },
        ],
      }}
    />
  );
}
